<template>
  <main>
    <div class="container">
      <!-- 新聞標題 -->
      <div class="news_title">
        <h3>{{ $t("news.newsNotice") }}</h3>
        <hr class="green" />
        <h5>News</h5>

        <p>
          <router-link :to="{ name: 'home' }">{{ $t("news.home") }}</router-link
          >> <a :to="{ name: 'news' }">{{ $t("news.news") }}</a
          >>
          <a class="active">{{ $t("news.body") }}</a>
        </p>
      </div>

      <!-- 新聞正文 -->
      <div class="news_body">
        <div class="news_info">
          <h3 v-html="news_data.title"></h3>
          <template v-if="$region == 'jp'">
            <p class="jp">
              <span
                v-html="
                  $t('news.time') + '：' + getDateString(news_data.publish_time)
                "
              ></span>
            </p>
          </template>
          <template v-else>
            <p>
              <span
                v-html="
                  $t('news.news') + '：' + getDateString(news_data.publish_time)
                "
              ></span>
              <span v-html="$t('news.author') + '：' + news_data.author"></span>
              <span v-html="$t('news.origin') + '：' + news_data.source"></span>
            </p>
          </template>
        </div>
        <hr />
        <div class="news_content" v-html="news_data.content"></div>
      </div>

      <!-- 返回鏈接 -->
      <div class="back_list">
        <router-link :to="{ name: 'news' }" ga-data="401001">
          <img src="../../assets/images/news/arrow_left_circle.svg" alt />
          {{ $t("news.backList") }}
        </router-link>
      </div>

      <!-- 回到顶部 -->
      <span
        class="toTop"
        v-if="scrollTopHigth > 600"
        @click="scrollsotp"
      ></span>
    </div>
  </main>
</template>

<script>
export default {
  props: {
    id: {
      required: true,
    },
  },
  name: "newsDetail",
  data() {
    return {
      news_data: {
        news_id: 0,
        type: 1,
        title: "",
        publish_time: "",
        author: "",
        source: "",
        content: "",
      },
      totop: false,
      scrollTopHigth: 0,
    };
  },
  methods: {
    getNewsType(id) {
      switch (id) {
        case 1:
          return this.$t("news.notice");
        //   break;
        case 2:
          return this.$t("news.preserve");
        //   break;
        case 3:
          return this.$t("news.news");
        //   break;
        case 4:
          return this.$t("news.active");
        //   break;
        case 5:
          return this.$t("news.declare");
        //   break;
        default:
          return id;
        //   break;
      }
    },
    // handleScroll() {
    //   if (
    //     self.pageYOffset ||
    //     document.documentElement.scrollTop ||
    //     document.body.scrollTop
    //   ) {
    //     this.totop = true;
    //   } else {
    //     this.totop = false;
    //   }
    // },
    getDateString(t) {
      if (!t) {
        return 0;
      }
      let ts = new Date(t);
      return ts.toLocaleDateString();
    },
    scrollsotp() {
      const currentY =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.scrollAnimation(currentY, 0);
    },
    scrollAnimation(currentY, targetY) {
      // 获取当前位置方法
      // 计算需要移动的距离
      let needScrollTop = targetY - currentY;
      let _currentY = currentY;
      setTimeout(() => {
        // 一次调用滑动帧数，每次调用会不一样
        const dist = Math.ceil(needScrollTop / 10);
        _currentY += dist;
        window.scrollTo(_currentY, currentY);
        // 如果移动幅度小于十个像素，直接移动，否则递归调用，实现动画效果
        if (needScrollTop > 10 || needScrollTop < -10) {
          this.scrollAnimation(_currentY, targetY);
        } else {
          window.scrollTo(_currentY, targetY);
        }
      }, 1);
    },
    listenerFunction() {
      document.addEventListener("scroll", this.handleScroll, true);
    },
    handleScroll() {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      this.scrollTopHigth = scrollTop;
    },
  },
  mounted() {
    // 请求置顶新闻
    this.listenerFunction();
    this.$apis.home.previewNewsDetail(this.id).then((data) => {
      let res = data.data;
      if (res.code == 0) {
        this.news_data = res.data;
      } else {
        // console.error(res.message);
      }
    });

    // window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.listenerFunction);
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/common.scss";
// 关于小萌，联系我们，会员规章
.contact-container {
  min-width: 1200px;
}
.main-block {
  width: 100%;
  max-width: 1200px;
  min-width: 1200px;
  margin: 0 auto;
  font-size: 20px;
}
.main-tit {
  height: 112px;
  padding-top: 80px;
  text-align: center;
  border-bottom: 1px solid #ccc;
  .tit-slice {
    width: 24px;
    height: 4px;
    background: #50bbe5;
    border-radius: 100px;
    vertical-align: middle;
  }
  .tit-en-des {
    font-size: 14px;
    color: #cccccc;
    letter-spacing: 0;
    line-height: 17px;
  }
  .tit-des {
    font-size: 32px;
    color: #444444;
    letter-spacing: 0;
  }
  span {
    display: inline-block;
  }
}
.main-con {
  .con-tit {
    padding-top: 61px;
    font-size: 24px;
    font-weight: bold;
    color: #50bbe5;
    line-height: 31px;
  }
  .con-block {
    padding-top: 30px;
    color: #444;
  }
  .con-about {
    font-size: 14px;
    line-height: 28px;
  }
}
body,
div,
p,
h3,
h4,
h5,
span {
  margin: 0;
  padding: 0;
  // font-weight: normal;
}
a {
  color: inherit;
  text-decoration: none;
}
main {
  min-width: 1366px;
}

.container {
  width: 1170px;
  margin: 0 auto;
  padding-top: 70px;
  min-height: calc(100vh - 242px);
  box-sizing: border-box;
  .news_title {
    text-align: center;
    padding: 10px 0;
    border-bottom: 1px solid #eeeeee;
    margin-bottom: 80px;
    h3 {
      font-size: 32px;
      color: #444444;
    }
    hr.green {
      width: 24px;
      height: 4px;
      border: 0;
      display: inline-block;
      margin: 10px 0;
      background: #50bbe5;
      border-radius: 2px;
    }
    h5 {
      font-size: 14px;
      color: #cccccc;
      margin-bottom: 40px;
    }
    p {
      text-align: left;
      font-size: 14px;
      color: #bdbdbd;
      .active {
        color: #444444;
      }
    }
  }
  .news_body {
    width: 870px;
    margin: 0 auto;
    .news_info {
      text-align: center;
      h3 {
        font-weight: bold;
        margin-bottom: 20px;
        font-size: 24px;
        color: #444444;
      }
      p {
        width: 484px;
        display: flex;
        margin: 0 auto;
        color: #ccc;
        justify-content: space-between;
        &.jp {
          justify-content: center;
        }
        span {
          flex-grow: 0;
          font-size: 12px;
        }
      }
    }
    hr {
      border: 0;
      height: 1px;
      background: #eeeeee;
      margin-top: 40px;
    }
    .news_content {
      padding: 40px 0;
      min-height: 400px;
      box-sizing: border-box;
    }
  }
  .back_list {
    border-top: 1px solid #eeeeee;
    text-align: center;
    padding: 20px;
    a {
      display: inline-block;
      width: 170px;
      height: 40px;
      border: 1px solid #50bbe5;
      border-radius: 20px;
      font-size: 14px;
      color: #333333;
      line-height: 40px;
      img {
        width: 12px;
      }
    }
  }
  .toTop {
    display: block;
    position: fixed;
    width: 48px;
    height: 64px;
    left: 50%;
    bottom: 80px;
    margin-left: 615px;
    background: url(../../assets/images/news/totop_nor.svg) center center
      no-repeat;
    background-size: contain;
    cursor: pointer;
    &:hover {
      background-image: url(../../assets/images/news/totop_hover.svg);
    }
    &:active {
      background-image: url(../../assets/images/news/totop_pressed.svg);
    }
  }
}
</style>
